module.exports = __webpack_public_path__ + "img/NormalSeat_Black.06df7114.png";